const addresses = [
  {
    id: 1,
    name: '857 Beatty Street',
    path: '/projects/857 Beatty Street',
  },
  {
    id: 2,
    name: 'Eatons Centre',
    path: '/projects/Eatons Centre',
  },
  {
    id: 3,
    name: 'Harbour Centre',
    path: '/projects/Harbour Centre',
  },
  {
    id: 4,
    name: '364 King Street W',
    path: '/projects/364 King Street W',
  },
  {
    id: 5,
    name: '205 Adelaide Ave',
    path: '/projects/205 Adelaide Ave',
  },
];

const countries = [
  {
    id: 1,
    name: 'United States',
    code: 1,
    flag: 'usa',
    alpha_2: 'US',
    country_code: '+1',
  },
  {
    id: 2,
    name: 'Canada',
    code: 1,
    flag: 'canada',
    alpha_2: 'CA',
    country_code: '+1',
  },
  {
    id: 3,
    name: 'United Kingdom',
    code: 44,
    flag: 'uk',
    alpha_2: 'GB',
    country_code: '+44',
  },
  {
    id: 4,
    name: 'Australia',
    code: 61,
    flag: 'aus',
    alpha_2: 'AAU',
    country_code: '+61',
  },
  {
    id: 5,
    name: 'New Zealand',
    code: 64,
    flag: 'nz',
    alpha_2: 'NZ',
    country_code: '+64',
  },
  {
    id: 6,
    name: 'United Arab Emirates',
    code: 971,
    flag: 'uae',
    alpha_2: 'AE',
    country_code: '+971',
  },
];

// Property Data
const projectClassifications = [
  {
    id: 1,
    value: 'Residential',
  },
  {
    id: 2,
    value: 'Commercial',
  },
  {
    id: 3,
    value: 'Both',
  },
];

export { addresses, countries, projectClassifications };
